/* Motor de landings de Trendy. Una sola copia para todas las fichas.
   Lo que cambia por producto es la PIEL (el css), nunca esta logica.

   Contrato de marcado:
     [data-tl-root]                  contenedor, con data-currency
     #tl-form  + input[name=id]      formulario de producto
     #tl-qty                         cantidad (la que manda al carrito)
     [data-tl-pack]                  boton de pack, con data-qty y data-desc (descuento en centavos)
     [data-tl-total] [data-tl-save] [data-tl-unit] [data-tl-price]
     [data-tl-image] + .tl-main-image
     [data-tl-cod] [data-tl-online] [data-tl-error]
     .tl-sticky + #tl-comprar

   Los packs se resuelven por CANTIDAD, no por variante: los descuentos los
   aplica Releasit por cantidad. Por eso el selector cambia #tl-qty y nada mas. */
(function () {
  function init() {
    var root = document.querySelector('[data-tl-root]');
    if (!root || root.dataset.listo) return;
    root.dataset.listo = '1';

    var datos = {};
    try { datos = JSON.parse(document.getElementById('tl-data').textContent); } catch (e) { return; }

    var form = root.querySelector('#tl-form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var qty = root.querySelector('#tl-qty');
    var err = root.querySelector('[data-tl-error]');
    var cod = root.querySelector('[data-tl-cod]');
    var online = root.querySelector('[data-tl-online]');
    if (!form || !idInput || !qty) return;

    // Formato identico al filtro money de Shopify: $1.190,00
    function plata(c) {
      var p = (c / 100).toFixed(2).split('.');
      return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
    }

    function packActivo() {
      return root.querySelector('[data-tl-pack][aria-checked="true"]') || root.querySelector('[data-tl-pack]');
    }

    function pintar() {
      var p = packActivo();
      var n = p ? Number(p.dataset.qty || 1) : Number(qty.value || 1);
      var desc = p ? Number(p.dataset.desc || 0) : 0;
      var total = datos.price * n - desc;
      var lista = (datos.compare || datos.price) * n;
      var ahorro = lista - total;

      root.querySelectorAll('[data-tl-total]').forEach(function (e) { e.textContent = plata(total); });
      root.querySelectorAll('[data-tl-unit]').forEach(function (e) { e.textContent = plata(Math.round(total / n)); });
      root.querySelectorAll('[data-tl-price]').forEach(function (e) { e.textContent = plata(total); });
      root.querySelectorAll('[data-tl-lista]').forEach(function (e) {
        e.textContent = plata(lista); e.hidden = !(lista > total);
      });
      root.querySelectorAll('[data-tl-save]').forEach(function (e) {
        e.textContent = plata(ahorro); e.hidden = !(ahorro > 0);
      });
      root.querySelectorAll('[data-tl-savebox]').forEach(function (e) { e.hidden = !(ahorro > 0); });
      root.querySelectorAll('[data-tl-off]').forEach(function (e) {
        if (lista > total) { e.textContent = Math.round(ahorro * 100 / lista) + '% OFF'; e.hidden = false; }
        else { e.hidden = true; }
      });
      qty.value = n;
    }

    root.querySelectorAll('[data-tl-pack]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-tl-pack]').forEach(function (x) {
          var on = x === b;
          x.setAttribute('aria-checked', String(on));
          x.tabIndex = on ? 0 : -1;
        });
        pintar();
      });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var todos = Array.prototype.slice.call(root.querySelectorAll('[data-tl-pack]'));
        var i = todos.indexOf(b);
        var paso = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        var sig = todos[(i + paso + todos.length) % todos.length];
        sig.click(); sig.focus();
      });
    });

    root.querySelectorAll('[data-tl-image]').forEach(function (b) {
      b.addEventListener('click', function () {
        var main = root.querySelector('.tl-main-image');
        if (!main) return;
        var base = b.dataset.tlImage;
        main.src = base + '&width=1200';
        main.srcset = [600, 900, 1200].map(function (w) { return base + '&width=' + w + ' ' + w + 'w'; }).join(', ');
        main.alt = b.getAttribute('aria-label') || '';
        root.querySelectorAll('[data-tl-image]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });

    function error() { if (err) { err.textContent = err.dataset.message; err.hidden = false; } }

    if (cod) cod.addEventListener('click', function (e) {
      if (err) err.hidden = true;
      if (!form.reportValidity()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      // Si Releasit no cargo, /rsi-btn-overwrite no lleva a ningun lado.
      if (!window._rsi || !window._rsi.form || !cod.classList.contains('_rsi-buy-now-button-product')) {
        e.preventDefault(); e.stopImmediatePropagation(); error();
      }
    }, true);

    /* 16-10-2026 (14.4): si el cliente volvía del checkout y tocaba de nuevo, el carrito quedaba con 2. Antes de agregar, las
       líneas de ESTE producto quedan en 0 (cart/update.js por key) y recién después se agrega lo elegido. No toca otros
       productos ni el pago al recibir (Releasit). Si la limpieza falla, se agrega igual: nunca se bloquea la compra. */
    function mismoProducto(it) {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      var pid = Number(root.getAttribute('data-product-id') || (meta && meta.id) || 0);
      if (pid && Number(it.product_id) === pid) return true;
      var ids = [Number(idInput.value)];
      root.querySelectorAll('[data-tf-variant]').forEach(function (b) { ids.push(Number(b.getAttribute('data-tf-variant'))); });
      return ids.indexOf(Number(it.variant_id)) > -1;
    }
    async function limpiar(pre) {
      try {
        var c = await fetch(pre + 'cart.js', { headers: { 'Accept': 'application/json' } });
        if (!c.ok) return;
        var cart = await c.json(), upd = {}, hay = false;
        (cart.items || []).forEach(function (it) { if (mismoProducto(it)) { upd[it.key] = 0; hay = true; } });
        if (!hay) return;
        await fetch(pre + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: upd })
        });
      } catch (e) {}
    }

    if (online) online.addEventListener('click', async function () {
      if (!form.reportValidity() || online.disabled) return;
      online.disabled = true; if (err) err.hidden = true;
      try {
        var pre = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
        await limpiar(pre);
        var r = await fetch(pre + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qty.value) }] })
        });
        if (!r.ok) throw new Error('cart');
        window.location.assign(pre + 'checkout');
      } catch (e) { error(); online.disabled = false; }
    });

    window.addEventListener('pageshow', function () { if (online) online.disabled = false; pintar(); });

    /* 10-10-2026: la barra fija (precio + Comprar) se ve desde la primera pantalla. Antes aparecia
       recien despues del bloque de compra y en la primera pantalla de un celular no habia ni precio ni
       boton. Ahora se oculta solo mientras los packs y los botones (#tl-form) estan en pantalla.
       El link solo baja hasta los packs: no compra nada. */
    var sticky = root.querySelector('.tl-sticky');
    var ancla = root.querySelector('#tl-comprar');
    var obj = root.querySelector('#tl-form') || ancla;
    if (sticky && obj && 'IntersectionObserver' in window) {
      var lnk = sticky.querySelector('a');
      new IntersectionObserver(function (es) {
        var e = es[0];
        sticky.hidden = e.isIntersecting;
        if (lnk) lnk.textContent = e.boundingClientRect.top > 0 ? 'Comprar ↓' : 'Comprar ↑';
      }, { threshold: 0 }).observe(obj);
      if (lnk) lnk.addEventListener('click', function (e) {
        var dest = root.querySelector('.tl-packs, .tf-precio') || obj;
        if (!dest || !dest.getBoundingClientRect) return;
        e.preventDefault();
        var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var arriba = dest.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, arriba), behavior: quieto ? 'auto' : 'smooth' });
      });
    }
    document.addEventListener('shopify:section:unload', function () { if (sticky) sticky.hidden = true; }, { once: true });

    pintar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
